<template>
  <div
    class="d-flex align-items-center justify-content-between mb-2"
  >
    <div
      class="d-flex align-items-center mb-2"
      @click.prevent="goBack"
    >
      <i
        class="material-icons-round opacity-10"
      >
        chevron_left
      </i>
      <span>Terug naar overzicht</span>
    </div>
    <div>
      <span
        v-if="isEditing"
        class="me-2"
        @click.prevent="cancelEditing"
      >
        Anulleren
      </span>
      <span
        class="me-2"
        @click.prevent="toggleState"
      >{{ stateButtonLabel }}</span>
      <span
        v-if="!isEditing"
        @click.prevent="deleteReport"
      >
        Verwijderen
      </span>
    </div>
  </div>
</template>

<script>
import ReportDetailStore from '@/store/pages/Report/report-detail-store';
import ReportEditStore, { EditState } from '@/store/pages/Report/report-edit-store';
import { createYesNoSweetAlert } from '@/helpers/sweetalert';
import { deleteReport } from '@/api/providers/reports';
import { mapActions } from 'vuex';
export default {
  computed: {
    isEditing() {
      return ReportEditStore.getters.isEditing;
    },

    editingState() {
      return ReportEditStore.getters.state;
    },

    stateButtonLabel() {
      return ReportEditStore.getters.state == EditState.viewing
        ? 'Bewerken'
        : 'Opslaan';
    }
  },

  methods: {
    ...mapActions('notification', {
      addNotification: 'add',
      addError: 'addError'
    }),

    goBack() {
      this.$router.go(-1)
    },

    cancelEditing() {
      ReportEditStore.dispatch('cancelEditing');
    },

    toggleState() {
      ReportEditStore.dispatch('updateState',
        this.editingState == EditState.viewing
          ? EditState.editing
          : EditState.viewing
      );
    },

    deleteReport() {
      createYesNoSweetAlert(
        'Weet u zeker dat u deze melding wilt verwijderen?',
        async () => {
          try {
            deleteReport(ReportDetailStore.getters.report.id),
            this.addNotification({
              description: `Melding is verwijderd.`,
              icon: {
                component: 'feedback',
              },
            });

            window.location.replace('/reports');
          }
          catch (e) {
            console.log(e)
          }
        }
      )
    }
  },
}
</script>

<style scoped>
div > * {
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
</style>